import React from "react";
import "./Popup.css";

const ConfirmPopup = ({ message, onConfirm, onCancel }) => (
  <div className='popup-backdrop'>
    <div className='popup confirm'>
      <h4>!Confirm</h4>
      <p>{message}</p>
      <div className='popup-confirm-actions'>
        <button className='popup-btn-cancel' onClick={onCancel}>Cancel</button>
        <button className='popup-btn-ok' onClick={onConfirm}>OK</button>
      </div>
    </div>
  </div>
);

export default ConfirmPopup;
